import React, { useState, useEffect, useCallback } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import {
    getGeneratedIcons,
    setUserStorage,
 } from '../../helpers'
import { deepCopy, randomReactKey, shuffleArray } from '../../utilities'
import { SubPageContainer } from '../App/components/SubPageContainer'
import { Progressbar } from '../../atoms/Progressbar'
import dayjs from 'dayjs'

// Tranlations
import t from '../../translations'

const Connection = (props) => {

    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const log = new URLSearchParams(location.search).get('log')
    const register = new URLSearchParams(location.search).get('register')
    const [loginStep, setLoginStep] = useState(0)
    const [registerStep, setRegisterStep] = useState(0)

    const utcOffset = dayjs().utcOffset()
    const [username, setUsername] = useState(log && props.user.username ? props.user.username : '')
    const [icons, setIcons] = useState([])
    const [registerIcons, setRegisterIcons] = useState([])
    const [challengeIdentifier, setChallengeIdentifier] = useState('')
    const [connectionRequestInProgress, setConnectionRequestInProgress] = useState(false)
    const [isFailedAttempt, setIsFailedAttempt] = useState(false)
    const [iconsRequestInProgress, setIconsRequestInProgress] = useState(false)
    const [registerIconsAccepted, setRegisterIconsAccepted] = useState(false)

    const [challengeCount, setChallengeCount] = useState(0)
    const [challengeAnswer, setChallengeAnswer] = useState([[], [], [], [], [], [], [], []])

    const [step2IconSelector, setStep2IconSelector] = useState([])
    const [step3IconSelector, setStep3IconSelector] = useState([])

    const wait = async (seconds) => new Promise(resolve => setTimeout(resolve, seconds * 1000))

    const getIconChallenge = useCallback(async () => {
        setIconsRequestInProgress(true)
        const iconChallengeResult = await getGeneratedIcons('in', username)
        setIconsRequestInProgress(false)

        if(!iconChallengeResult || !iconChallengeResult.i || !iconChallengeResult.ii){
            return
        }

        // Add indexes and default selected false
        const i = iconChallengeResult.i.map((challenge) => challenge.map(
            (icon, index) => {
                icon.index = index
                icon.selected = false

                return icon
            })
        )
        const ii = iconChallengeResult.ii

        setIcons(i)
        setChallengeIdentifier(ii)

        let iconsCopyToRegister = deepCopy(i)
        setRegisterIcons(iconsCopyToRegister)
        setChallengeAnswer([[], [], [], [], [], [], [], []])
        setStep2IconSelector(shuffleArray(deepCopy(iconsCopyToRegister[0])))
        setStep3IconSelector(shuffleArray(deepCopy(iconsCopyToRegister[0])))

    }, [username, setRegisterIcons, setChallengeAnswer])

    useEffect(() => {
        setLoginStep(0)
        setRegisterStep(0)
    }, [log, register])

    const getSelectedIcons = useCallback((iconList) => {
        return iconList.filter((icon) => icon.selected)
    }, [])

    const getNames = (iconList) => {
        return iconList.map((icon) => icon.name)
    }

    useEffect(() => {
        const isConnected = props.user.connected

        const connectionRequest = (tz, log, u, i, ii) => {
            if (!connectionRequestInProgress && ((log !== 'out' && u && i) || (log === 'out' && isConnected))) {
                ;(async () => {
                    const response = await setUserStorage(props.checkServerUp, props.noUser, props.setUser, tz, log, u, i, ii, props.user.sessionToken)

                    if(response.success){
                        setIcons([])
                        searchParams.delete('log')
                        searchParams.delete('register')
                        setSearchParams(searchParams)
                        window.location.pathname = '/'
                        

                    } else {
                        setConnectionRequestInProgress(false)
                        setIsFailedAttempt(true)
                        setLoginStep(4)
                    }
                })()
            }
        }

        // Logout automatically
        if(log === 'out'){
            connectionRequest(
                utcOffset,
                log,
                username
            )
        }

        // Register
        // TODO: Register out (delete my account)
        if(register === 'in' && registerStep > 7 && registerIconsAccepted){  //  || register === 'out'
            setConnectionRequestInProgress(true)
            connectionRequest(
                utcOffset,
                register === 'in' ? 'new' : '', // : 'delete'
                username,
                JSON.stringify(getSelectedIcons(step2IconSelector)),
                challengeIdentifier,
            )
        }

        if(loginStep === 0 || registerStep === 1)(
            document.querySelector('input')?.focus()
        )

        // login when all challenges submitted
        if(log === 'in' && loginStep === 2)(
            connectionRequest(
                utcOffset,
                log,
                username,
                JSON.stringify(challengeAnswer),
                challengeIdentifier,
            )
        )

    }, [props, log, register, loginStep, registerStep, username, challengeIdentifier, utcOffset, registerIconsAccepted, challengeAnswer, getSelectedIcons, step2IconSelector, connectionRequestInProgress, searchParams, setSearchParams])

    const iconSelect = (iconIndex) => {

        // Login answers
        loginStep === 1 && setChallengeAnswer((previousState) => {
            const state = deepCopy(previousState)

            if(!state[challengeCount].includes(iconIndex)){
                state[challengeCount] = state[challengeCount].concat(iconIndex)
            } else {
                const index = state[challengeCount].indexOf(iconIndex)
                state[challengeCount].splice(index, 1)
            }

            return state
        });

        // Register big challenge Answer
        registerStep === 5 && setRegisterIcons((previousState) => {
            let state = deepCopy(previousState)
            
            const value = state[challengeCount][iconIndex].selected
            state[challengeCount][iconIndex].selected = !value

            return state
        })

        // Store selected icons
        registerStep === 2 && setStep2IconSelector((previousState) => {
            let state = deepCopy(previousState)
            
            const value = state[iconIndex].selected
            state[iconIndex].selected = !value

            return state
        })

        // Register first challenge
        registerStep === 3 && setStep3IconSelector((previousState) => {
            let state = deepCopy(previousState)
            
            const value = state[iconIndex].selected
            state[iconIndex].selected = !value

            return state
        })

        setIsFailedAttempt(false)
    }

    const iconUnselect = (iconList) => {
        return iconList.map((icon) => {
            icon.selected = false
            return icon
        })
    }

    const iconMapHandler = (icon, iconIndex) => {
        return <>
            <input
                key={randomReactKey()}
                className='hidden'
                type='checkbox'
                name='itemASelection'
                checked={
                    (log === 'in' && challengeAnswer[challengeCount].includes(iconIndex))
                    ||
                    (register === 'in' && registerStep !== 3 && registerIcons[challengeCount][iconIndex].selected)
                    ||
                    (register === 'in' &&  (registerStep === 2 || registerStep === 3) && icon.selected)
                }
                onChange={() => {}}
            />
            <box-icon
                key={randomReactKey()}
                type={icon.type}
                name={icon.name}
                data-name={icon.name}
                data-color={icon.color}
                color={icon.color}
                onClick={() => iconSelect(iconIndex)}
            />
        </>
    }

    const userNameInput = (toStep, getChallenge) => <>
        <div>
            <input
                className='username'
                type='text'
                value={username}
                maxLength={30}
                onChange={(event) => {
                    setUsername(event.target.value)
                }}
                onKeyUp={(event) => {
                    if(event.key === 'Enter'){
                        setLoginStep(toStep)
                    }
                }}
            />
        </div>
    </>

    const stepIcon = (state, disabled, clickHandler ) => {

        let classes = 'active'
        if(!clickHandler){
            clickHandler = () => {}
            classes = ''
        }

        const icons = [
            {name: 'skip-next', color: 'grey', type: 'regular'},
            {name: 'check', color: 'green', type: 'regular'},
            {name: 'x', color: 'red', type: 'regular'},
        ]

        let iconIndex
        if(state === 'available'){
            classes += ' iconCircleGrey'
            iconIndex = 0
        }
        if(state === 'done'){
            classes += ' iconCircleGreen'
            iconIndex = 1
        }
        if(state === 'failed'){
            classes += ' iconCircleRed'
            iconIndex = 2
        }
        if(disabled){
            classes += ' disabled'
        }
        return <div className={`icon ${disabled && 'disabled'}`}>
            <div className={`iconCircle ${classes}`}>
                <box-icon {...icons[iconIndex]}
                    onClick={(event) => clickHandler(event, iconIndex)}
                />
            </div>
        </div>
    }

    // Register icons
    const registerIcon1 = () => {
        if(registerStep > 1){
            return 'done'
        }

        return 'available'
    }

    const registerIcon2 = () => {
        if(registerStep === 2 && icons.length === 0 && !iconsRequestInProgress){
            return 'failed'
        }

        return registerStep > 2 && getSelectedIcons(step2IconSelector).length === 3 ? 'done' : 'available'
    }

    const registerIcon3 = () => {
        if(registerStep >= 4){
            return validateIconSelection() ? 'done' : 'failed'
        }

        return 'available'
    }

    const registerIcon4 = () => {
        if(registerStep > 5 && challengeCount === 8){
            return validateRegisterChallenge().result ? 'done' : 'failed'
        }

        return 'available'
    }

    const loginStep2Icon = () => {
        if(isFailedAttempt){
            return 'failed'
        }
        if(challengeCount === 8){
            return 'done'
        }

        return 'available'
    }

    // Login actions
    const clearChallengeResponses = () => {
        getIconChallenge()
        setLoginStep(0)
        setChallengeCount(0)
        setChallengeAnswer([[], [], [], [], [], [], [], []])
        setIsFailedAttempt(false)
    }

    const loginBackToStep0 = () => {
        setLoginStep(0)
        setChallengeCount(0)
    }

    const loginStep0Continue = () => {
        getIconChallenge()
        setLoginStep(1)
    }

    const loginStep1Continue = async () => {
        if(challengeCount < 8){
            setChallengeCount(challengeCount + 1)
            if(challengeCount + 1 === 8){
                await wait(0.6)
                setLoginStep(2)
            }
        }
    }

    // Register actions
    const RegisterStep0Continue = () => {
        setRegisterStep(1)
    }

    const RegisterStep1Continue = () => {
        getIconChallenge()
        setRegisterStep(2)
    }

    const registerStep2Continue = () => {
        setRegisterStep(3)
        setStep3IconSelector((previousState) => iconUnselect(previousState))
    }

    const registerStep3Continue = () => {
        setRegisterStep(4)
    }

    const registerStep4Continue = () => {
        setRegisterStep(5)
    }

    const registerStep5Continue = async () => {
        if(challengeCount < 8){
            setChallengeCount(challengeCount + 1)
            if(challengeCount + 1 === 8){
                await wait(0.6)
                setRegisterStep(6)
            }
        }
    }

    /* Register steps

    0 - Explanations
    1 - Enter username
    2 - Icon challenges selection (with 3 icons present)
    3 - Verify icon selection

    4 - Result of the step 3 + explanations
    5 - (on step 3 success) All challenges attempts like a real login

    6 - Result of the step 5
    7 - Connection success

    */

    const validateIconSelection = () => {
        const selectedNames = getNames(getSelectedIcons(step2IconSelector)).sort()
        
        const verificationNames = getNames(getSelectedIcons(step3IconSelector)).sort()

        return JSON.stringify(selectedNames) === JSON.stringify(verificationNames)
    }

    const validateRegisterChallenge = () => {

        const goodIcons = step2IconSelector.filter((icon) => icon.selected)
        let successResults = []

        const selectedIconDisplay = registerIcons.map((registerChallenge, index) => {

            // Check all good that were present in challenge
            let present =  goodIcons.filter((good) => !!registerChallenge.find((icon) => icon.name === good.name))

            const selectedIcons = getSelectedIcons(registerChallenge)

            const success = JSON.stringify(getNames(present).sort()) === JSON.stringify(getNames(selectedIcons).sort())
            successResults.push(success)

            return <>
                <div className={`challengeValidation ${success ? 'good' : 'wrong'}`}>
                    {
                        selectedIcons.length === 0 ?
                            <div>{t[props.lang]['None']}</div>
                            :
                            <div>
                                {selectedIcons.map((icon) => <box-icon
                                    key={randomReactKey()}
                                    type={icon.type}
                                    name={icon.name}
                                    data-name={icon.name}
                                    data-color={icon.color}
                                    color={icon.color}
                                />)}
                            </div>
                    }
                </div>
            </>
        })

        const allGood = successResults.filter((s) => s).length === 8

        return {
            display: <>
                {selectedIconDisplay}
                {allGood ?
                    <>
                        <button
                            className='registerValidation'
                            onClick={() => {
                                setRegisterIconsAccepted(true)
                                setRegisterStep(7)
                            }}
                        >
                            {t[props.lang]['UseIcons']}
                        </button>
                    </> :
                    <>
                        <button
                            onClick={() => {
                                setRegisterStep(5)
                                const iconsCopy = deepCopy(icons)
                                setRegisterIcons(iconsCopy)
                                setChallengeCount(0)
                            }}
                        >
                            {t[props.lang]['StartOver']}
                        </button>

                        <button
                            onClick={() => {
                                setRegisterStep(2)
                                setStep2IconSelector((previousState) => iconUnselect(previousState))
                                const iconsCopy = deepCopy(icons)
                                setRegisterIcons(iconsCopy)
                                setChallengeCount(0)
                            }}
                        >
                            {t[props.lang]['ChangeIcons']}
                        </button>
                    </>}
            </>,
            result: allGood,
        }
    }

    if(register){
        return <SubPageContainer>

            {registerStep === 0 && <>
                <h1>{t[props.lang]['Create account']}</h1>
                <div>
                    <p className='center'>{t[props.lang]['Creation steps']}</p>
                </div>
                <button
                    onClick={RegisterStep0Continue}
                >
                    {t[props.lang]['Continue']}
                </button>
            </>}

            {registerStep === 1 && <>
                <h1>{t[props.lang]['ChooseUsername']}</h1>
                {userNameInput(2, true)}
                <button
                    className={`${username.length < 5 ? 'disabled' : ''}`}
                    disabled={username.length < 5}
                    onClick={RegisterStep1Continue}
                >
                    {t[props.lang]['Continue']}
                </button>
            </>}

            {registerStep === 2 && icons.length === 0 && !iconsRequestInProgress && <>
                <h1>{t[props.lang]['Try again later']}</h1>
            </>}

            {registerStep === 2 && icons.length > 0 && <>
                <h1>{t[props.lang]['ChooseIcons']}</h1>
                {icons.length > 0 ?
                    <div className='memSelectors'>
                        <div className='iconSelection'>
                            {!iconsRequestInProgress && step2IconSelector.map(iconMapHandler)}
                        </div>
                        <button
                            className={getSelectedIcons(step2IconSelector).length !== 3 ? 'disabled' : ''}
                            disabled={getSelectedIcons(step2IconSelector).length !== 3}
                            onClick={registerStep2Continue}
                        >
                            {t[props.lang]['Continue']}
                        </button>
                    </div> : <div className='memSelectors'></div>
                }
            </>}

            {registerStep === 3 && <>
                <h1>{t[props.lang]['FindIcons']}</h1>
                <div className='memSelectors'>
                    <div className='iconSelection'>
                        {step3IconSelector.map(iconMapHandler)}
                    </div>
                    <button
                        className={getSelectedIcons(step3IconSelector).length !== 3 ? 'disabled' : ''}
                        disabled={getSelectedIcons(step3IconSelector).length !== 3}
                        onClick={registerStep3Continue}
                    >
                        {t[props.lang]['Continue']}
                    </button>
                </div>
            </>}

            {registerStep === 4 && <>
                <h3>{username}! {t[props.lang]['ShowIcons']}</h3>
                <div className='showMyIcons'>
                    {getSelectedIcons(step2IconSelector)
                        .map((icon) => <box-icon
                            key={randomReactKey()}
                            type={icon.type}
                            name={icon.name}
                            data-name={icon.name}
                            data-color={icon.color}
                            color={icon.color}
                        />)
                    }
                </div>

                <p className={`center iconSelectionValidation ${validateIconSelection() ? 'good' : 'bad'}`}>
                    {validateIconSelection() ? t[props.lang]['Succeeded'] : t[props.lang]['Failed']}.
                </p>

                {validateIconSelection() && t[props.lang]['challengeExplanations']}

                {validateIconSelection() ? <button
                    onClick={registerStep4Continue}
                >
                    {t[props.lang]['Continue']}
                </button> :
                <button
                    onClick={registerStep2Continue}
                >
                    {t[props.lang]['StartOver']}
                </button>}
            </>}

            {registerStep === 5 && <>
                <h1>{t[props.lang]['Find your icons']}</h1>
                {challengeCount < 8 ? <div className='memSelectors'>
                    <div className='iconSelection'>
                        {registerIcons[challengeCount].map(iconMapHandler)}
                    </div>
                    <button
                        onClick={async () => {await registerStep5Continue()}}
                    >
                        {t[props.lang]['Continue']}
                    </button>
                </div> : <div className='memSelectors'></div>}
                <Progressbar step={challengeCount} totalSteps={8}/>
            </>}

            {registerStep === 6 && <>
                <h1>{t[props.lang]['AttempsValidation']}</h1>
                
                <div className='flex-column'>
                    {validateRegisterChallenge().display}
                </div>
            </>}

            {registerStep === 7 && <>
                <h1>Étape finale</h1>
                
                {t[props.lang]['Warning']}

                <div className='showMyIcons'>
                    {getSelectedIcons(step2IconSelector)
                        .map((icon) => <box-icon
                            key={randomReactKey()}
                            type={icon.type}
                            name={icon.name}
                            data-name={icon.name}
                            data-color={icon.color}
                            color={icon.color}
                        />)}
                </div>

                {t[props.lang]['Welcome']}

                <button
                        onClick={() => setRegisterStep(8)}
                    >
                        {t[props.lang]['CreateAccount']}
                    </button>
            </>}

            {/* Register Step icons */}
            <div className='registerProgress'>
                <div className='row'>
                    {stepIcon(
                        registerIcon1(),
                        false,
                    )}
                    <div className='step'>
                        <div>{t[props.lang]['ChooseUsername']}</div>
                    </div>
                </div>
                <div className='row'>
                    {stepIcon(
                        registerIcon2(),
                        registerStep < 2,
                    )}
                    <div className='step'>
                        <div>{t[props.lang]['ChooseIcons']}</div>
                    </div>
                </div>
                <div className='row'>
                    {stepIcon(
                        registerIcon3(),
                        registerStep < 3,
                    )}
                    <div className='step'>
                        <div>{t[props.lang]['ConfirmIcons']}</div>
                    </div>
                </div>
                <div className='row'>
                    {stepIcon(
                        registerIcon4(),
                        registerStep < 4,
                    )}
                    <div className='step'>
                        <div>{t[props.lang]['Challenge']}</div>
                    </div>
                </div>
                <div className='row'>
                    {stepIcon(
                        registerIconsAccepted ? 'done' : 'available',
                        registerStep < 6 || !validateRegisterChallenge().result
                    )}
                    <div className='step'>
                        <div>{t[props.lang]['Connect']}</div>
                    </div>
                </div>
            </div>
        </SubPageContainer>
    }

    /* Login steps

    0 - Enter username
    1 - Icon challenges
    2 - Connection in progress
    3 - Connection success
    4 - Retry challenges step

    */

    return log === 'out' ? <></> : <SubPageContainer>
        {!connectionRequestInProgress && <>
            {loginStep === 0 && <>
                <h1>{t[props.lang]['Username:']}</h1>
                {userNameInput(1, true)}
                <button
                    onClick={loginStep0Continue}
                >
                    {t[props.lang]['Continue']}
                </button>
            </>}

            {loginStep === 1 && icons.length === 0 && !iconsRequestInProgress && <>
                <h1>{t[props.lang]['Try again later']}</h1>
            </>}

            {loginStep === 1 && <>
                <h1>{t[props.lang]['Find your icons']}</h1>
                {icons.length > 0 && challengeCount < 8 ?
                    <div className='memSelectors'>
                        <div className='iconSelection'>
                            {!iconsRequestInProgress && icons[challengeCount].map(iconMapHandler)}
                        </div>
                        <button
                            className={challengeAnswer[challengeCount].length >= 4 ? 'disabled' : ''}
                            disabled={challengeAnswer[challengeCount].length >= 4}
                            onClick={async () => {await loginStep1Continue()}}
                        >
                            {t[props.lang]['Continue']}
                        </button>
                    </div> : <div className='memSelectors'></div>
                }
                <Progressbar step={challengeCount} totalSteps={8}/>
            </>}

            {/* Login Step icons */}
            {loginStep !== 3 ? <div className='registerProgress'>
                <div className='row'>
                    {stepIcon(
                        username.length >= 5 ? 'done' : 'available',
                        false,
                        loginStep > 0 && loginBackToStep0
                    )}
                    <div className='step'>
                        <div>{t[props.lang]['EnterUsername']}</div>
                    </div>
                </div>
                <div className='row'>
                    {stepIcon(
                        loginStep2Icon(),
                        username.length < 5
                    )}
                    <div className='step'>
                        <div>{t[props.lang]['Find your icons']}</div>
                    </div>
                </div>
            </div> :
            <div>
                <h1>{t[props.lang]['Connecting']}</h1>
            </div>}

            {/* Retry challenges button */}
            {loginStep === 4 && <button
                onClick={() => clearChallengeResponses()}
            >
                {t[props.lang]['StartOver']}
            </button>}
        </>}
    </SubPageContainer>
}

export default Connection